import React from 'react';
import PropTypes from 'prop-types';

export const MinusIcon = props => (
    <svg width={props.width} height={props.height} viewBox="0 0 52 52" {...props}>
        <g fill="#767676">
            <path
                d="M26 0C11.664 0 0 11.663 0 26s11.664 26 26 26 26-11.663 26-26S40.336 0 26 0zm0 50C12.767 50 2 39.233 2 26S12.767 2 26
        2s24 10.767 24 24-10.767 24-24 24z"
            />
            <path d="M39 25H13a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2z" />
        </g>
    </svg>
);

MinusIcon.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
};
